import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { AllowanceQueryParams, UserAllowance } from '@frontend/budget/types';

export class AllowanceClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async postGetUserAllowancesV2(
        ids: string[],
        queryParams?: ApiQueryParams<AllowanceQueryParams>,
        withCredentials?: Token
    ): Promise<UserAllowance> {
        const response = await this.postWithQueryParams(`${this.endpoint}/product-allowance`, queryParams, { ids: ids }, true, withCredentials);
        return await this.handleResponse<UserAllowance>(response);
    }

    public static async postGetUserAllowancesForUser(
        ids: string[],
        userId: string,
        queryParams?: ApiQueryParams<AllowanceQueryParams>,
        withCredentials?: Token
    ): Promise<UserAllowance> {
        const response = await this.postWithQueryParams(`${this.endpoint}/product-allowance`, queryParams, { ids, user_id: userId }, true, withCredentials);
        return await this.handleResponse<UserAllowance>(response);
    }

    public static async postGetAccountUserAllowances(
        accountId: string,
        userId: string,
        ids: string[],
        queryParams?: ApiQueryParams<AllowanceQueryParams>,
        withCredentials?: Token
    ): Promise<UserAllowance> {
        const response = await this.postWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/users/${userId}/product-allowance`,
            queryParams,
            { ids },
            true,
            withCredentials
        );
        return await this.handleResponse<UserAllowance>(response);
    }

    public static async postGetUserAllowances(spotId: string, ids: string[], withCredentials?: Token): Promise<UserAllowance> {
        const response = await this.postWithQueryParams(`${this.endpoint}/product-allowance`, { spot_id: spotId }, { ids: ids }, true, withCredentials);
        return await this.handleResponse<UserAllowance>(response);
    }

    public static async postGetUserCategoryAllowances2(
        ids: string[],
        queryParams?: ApiQueryParams<AllowanceQueryParams>,
        withCredentials?: Token
    ): Promise<UserAllowance> {
        const response = await this.postWithQueryParams(`${this.endpoint}/product-category-allowance`, queryParams, { ids: ids }, true, withCredentials);
        return await this.handleResponse<UserAllowance>(response);
    }

    public static async postGetUserCategoryAllowances(spotId: string, ids: string[], withCredentials?: Token): Promise<UserAllowance> {
        const response = await this.postWithQueryParams(
            `${this.endpoint}/product-category-allowance`,
            { spot_id: spotId },
            { ids: ids },
            true,
            withCredentials
        );
        return await this.handleResponse<UserAllowance>(response);
    }
}
